<template>
  <div class="edit-recipe wrapper">

    <div>
      <BaseErrors :errors="errors"></BaseErrors>

      <div class="row" v-if="brewSessions">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Brew sessions</h5>
              <div v-if="loading" class="text-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>

              <ul class="streams-list">
                <li v-for="brewSession in brewSessions">
                  <div class="top-section">
                    <div class="name">
                      <span v-if="brewSession.live" class="badge badge-danger">Live</span>
                      <a :href="`/app/recipes/` + brewSession.recipeId">
                        {{brewSession.date}} -
                        {{brewSession.recipeName}}
                      </a>
                    </div>
                    <a href="#"
                       class="delete-session"
                       :data-id="brewSession.id"
                       @click.prevent="deleteBrewSession">
                      <BaseIcon name="delete"
                                title="Delete this session"
                                width="20"
                                height="20"></BaseIcon>
                    </a>

                  </div>
                  <div class="top-section">Fermentation logs: {{brewSession.records}}</div>

                  <div class="actions">
                    <router-link class="btn btn-outline-secondary btn-sm"
                                 :to="{ name: 'brew-session-edit', params: { id: brewSession.id }}">Edit</router-link>
                  </div>
                </li>
              </ul>

              <form @submit.prevent="createBrewSession">
                <div class="form-group">
                    <label for="brew-session-recipe-select">Create a new brew session</label>
                    <select class="form-control"
                            v-model="selectedBrewSessionRecipeId"
                            id="brew-session-recipe-select">
                      <option v-for="recipe in recipes" :value="recipe.id">{{recipe.name}}</option>
                    </select>
                </div>
                <div>
                  <button type="submit" class="btn btn-primary btn-sm">Create a Brew Session</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="streams">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Streams</h5>

              <ul class="streams-list">
                <li v-for="stream in streams">
                  <div class="top-section">
                    <div class="name"><h5>{{stream.name}}</h5></div>
                    <a href="#"
                       class="delete-strean"
                       :data-id="stream.id"
                       @click.prevent="deleteStream">
                      <BaseIcon name="delete"
                                title="Delete this stream"
                                width="20"
                                height="20"></BaseIcon>
                    </a>
                  </div>
                  <div class="url">{{stream.self}}</div>
                  <div class="stream-brew-session">
                    <div class="form-group">
                      <label for="stream-brew-session-select"><span v-if="stream.active" class="badge badge-danger">Live</span>
                        Streaming to:</label>
                      <select @change="updateStream" :data-id="stream.slug" class="form-control" id="stream-brew-session-select">
                        <option value="">Select Session</option>
                        <option v-for="brewSession in brewSessions"
                                :selected="stream.brewSessionId == brewSession.id"
                                :value="brewSession.id">
                          {{brewSession.name}}
                        </option>
                      </select>
                    </div>
                  </div>
                </li>
              </ul>

              <form @submit.prevent="createStream">
                <div class="form-group">
                  <label for="stream-name-input">Stream name</label>
                  <input type="text" v-model="streamName"  class="form-control" id="stream-name-input">
                </div>
                <button type="submit" class="btn btn-primary">Create a stream</button>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { HTTP } from '../lib/http';
    import { EventBus } from '../lib/event-bus.js';

    export default {
        name: "streams",
        components: {
        },
        data() {
            return {
                streams: null,
                brewSessions: null,
                recipes: null,
                errors: null,
                loading: true,
                selectedBrewSessionRecipeId: null,
                selectedBrewSession: null,
                streamName: null,
                loggedIn: false,
                params: {
                  pagination: { number: 1, size: 3 },
                  sort: { created_at: 'DESC' }
              }
            };
        },
        methods: {
            fetchStreams() {
                HTTP.get("streams")
                    .then(response => {
                        this.streams = response.data.data;
                    })
                    .catch(err => {
                        this.errors = [err.response.data.message];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            fetchBrewSessions() {
                HTTP.get(`brew-sessions${this.getQueryParams(this.params)}`)
                    .then(response => {
                        this.brewSessions = response.data.data;

                    })
                    .catch(err => {
                        this.errors = [err.response.data.message];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            fetchRecipes() {
                HTTP.get("member-recipes")
                    .then(response => {
                        this.recipes = response.data.data;
                        this.selectedBrewSessionRecipeId = this.recipes[0].id
                    })
                    .catch(err => {
                        this.errors = [err.response.data.message];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            createBrewSession() {
                HTTP.post("brew-sessions", { data: {
                        recipeId: this.selectedBrewSessionRecipeId
                    }
                })
                    .then(response => {
                        this.fetchBrewSessions();
                        this.fetchStreams();
                    })
                    .catch(err => {
                        this.errors = [err.response.data.message];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            createStream() {
                HTTP.post("streams", { data: {
                        name: this.streamName
                    }
                })
                    .then(response => {
                        // this.recipes = response.data.data;
                        this.fetchBrewSessions();
                        this.fetchStreams();
                    })
                    .catch(err => {
                        this.errors = [err.response.data.message];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            updateStream(e) {
                const itemId = e.currentTarget.getAttribute('data-id');
                const brewSessionId = e.currentTarget.value;

                HTTP.patch("streams/" + itemId, { data: {
                        brewSessionId: brewSessionId
                    }
                })
                    .then(response => {
                        // this.recipes = response.data.data;
                        this.fetchBrewSessions();
                        this.fetchStreams();
                    })
                    .catch(err => {
                        this.errors = [err.response.data.message];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            deleteBrewSession(e) {
                if (confirm('Are you sure?')) {
                    const itemId = e.currentTarget.getAttribute('data-id');
                    HTTP.delete("brew-sessions/" + itemId)
                        .then(response => {
                            this.fetchBrewSessions();
                            this.fetchStreams();
                        })
                        .catch(err => {
                            this.errors = [err.response.data.message];
                        })
                        .then(() => {
                            this.loading = false;
                        });
                }
            },
            deleteStream(e) {
                if (confirm('Are you sure?')) {
                    const itemId = e.currentTarget.getAttribute('data-id');
                    HTTP.delete("streams/" + itemId)
                        .then(response => {
                            this.fetchBrewSessions();
                            this.fetchStreams();
                        })
                        .catch(err => {
                            this.errors = [err.response.data.message];
                        })
                        .then(() => {
                            this.loading = false;
                        });
                }
            }
        },
        beforeMount() {
            this.loggedIn = !!localStorage.username;
            EventBus.$on('logged-in', val => { this.loggedIn = val; });
        },
        mounted() {
            if (this.loggedIn) {
                this.fetchBrewSessions();
                this.fetchStreams();
                this.fetchRecipes();
            }
        },
    };
</script>

<style scoped lang="scss">
  .streams-list {
    list-style-type: none;
    padding: 0;

    li {
      margin-bottom: 2.5em;
    }

    .top-section {
      display: flex;
      justify-content: space-between;
      margin-bottom: .5em;

      .name {
        text-transform: capitalize;
      }
    }
    .url {
      unicode-bidi: embed;
      font-family: monospace;
      white-space: pre;
    }
  }

</style>
